import { useEffect, useState, useCallback, version, useRef } from "react";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import create_profile_icon from "../../assets/images/create_profile_icon.png";
import login_hero_image from "../../assets/images/login-hero.jpg";
import BrandLogo from "../../components/BrandLogo/BrandLogo";
import { Col, Form, Row } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import ReCAPTCHA from "react-google-recaptcha";
import * as constants from "../../constants/Constants";
import { isStaffRole, isSupplierRole, staffLandingPath } from "../../constants/roles";

const Login = () => {
  const [step, setStep] = useState(1);
  const [fullNumber, setFullNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [isNumberValid, setIsNumberValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [OTPErrorMessage, setOTPErrorMessage] = useState("");

  const [captchaError, setCaptchaError] = useState("");
  const [showMailLogin, setShowMailLogin] = useState(false);
  const [errorMessageMail, setErrorMessageMail] = useState("");
  const [otp, setOtp] = useState("");
  const [count, setCount] = useState(120);
  const [otpRes, setOtpRes] = useState({});
  const [resendEnabled, setResendEnabled] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const [isSetPasswordFlow, setIsSetPasswordFlow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [resetStep, setResetStep] = useState(1);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewForgotPassword, setShowNewForgotPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // Validate phone number input
  //   const numberOnChanges = async (value, country, formattedValue) => {
  //     setFullNumber(value);
  // console.log(value, country,"value, country")
  //     // Define minimum length requirements for each country
  //     const countryMinLengths = {
  //       in: 10, // India: 10 digits
  //       ae: 9, // UAE: 9 digits (excluding country code)
  //     };

  //     const minLength = countryMinLengths[country.countryCode] || 10;
  //     const phoneNumberWithoutCode = value.replace(country.dialCode, "").trim();

  //     if (phoneNumberWithoutCode.length >= minLength) {
  //       setIsNumberValid(true);
  //       setErrorMessage("");
  //       setCountryCode(country.dialCode);
  //       setPhoneNumber(phoneNumberWithoutCode);
  //     } else {
  //       setIsNumberValid(false);
  //       setErrorMessage(
  //         `Please enter a valid ${country.name} phone number (minimum ${minLength} digits)`
  //       );
  //     }
  //   };
  const countryRules = {
    in: {
      length: 10,
      regex: /^[6-9]\d{9}$/ // starts with 6-9
    },
    ae: {
      length: 9,
      regex: /^(50|52|54|55|56|58)\d{7}$/ // valid UAE prefixes
    }
  };

  const numberOnChanges = (value, country) => {
    const rule = countryRules[country.countryCode] || {
      length: 10,
      regex: /^\d+$/
    };

    let number = value.slice(country.dialCode.length).replace(/\D/g, "");

    // HARD LIMIT
    if (number.length > rule.length) {
      number = number.slice(0, rule.length);
    }

    const full = country.dialCode + number;
    setFullNumber(full);

    //  VALIDATION (length + format)
    if (number.length === rule.length && rule.regex.test(number)) {
      setIsNumberValid(true);
      setErrorMessage("");
      setCountryCode(country.dialCode);
      setPhoneNumber(number);
    } else {
      setIsNumberValid(false);
      setErrorMessage(
        `Please enter a valid ${country.name} mobile number (minimum ${rule.length} digits)`
      );
    }
  };
  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };
  // Generate OTP
  const getOTP = async (isResend = false) => {
    setErrorMessage("");
    setCaptchaError("");

    if (!isNumberValid) {
      setErrorMessage("Please enter a valid mobile number.");
      return;
    }

    //  ONLY CHECK CAPTCHA FOR FIRST TIME
    if (!isResend && !captchaToken) {
      setCaptchaError("Please complete reCAPTCHA.");
      return;
    }

    try {
      setLoader(true);

      const data = {
        mobileNumber: fullNumber,
        is_mobile: true,
        is_resend: isResend,
        ...(!isResend && { "g-recaptcha-response": captchaToken })
      };

      const res = await apicall.post(data, "ezp_mobile_login");

      if (!res?.success) {
        toast.error(res?.message || "Failed to send OTP. Please try again.");
        return;
      }

      // AFTER SUCCESS
      setOtp("");
      setCount(120);
      setResendEnabled(false);
      setOtpRes(res);
      setStep(2);

      if (isResend) {
        toast.success("OTP has been resent. Please check your phone.");
      }

      // reset captcha ONLY for first request
      if (!isResend) {
        recaptchaRef.current.reset();
        setCaptchaToken(null);
      }
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  const emailSend = async (isResend = false, isForgotFlow = false) => {
    setOTPErrorMessage("");
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emailValue = email.trim();

    if (!emailValue || !emailRegex.test(emailValue)) {
      setErrorMessageMail("Enter valid email");
      return;
    }

    if (!isResend && !isForgotFlow && !captchaToken) {
      setCaptchaError("Please complete reCAPTCHA.");
      return;
    }

    try {
      setLoader(true);

      const res = await apicall.post(
        {
          email: emailValue,
          type: isForgotFlow ? "forgot_password" : "login"
        },
        "ezp_email_login"
      );
      setOtp("");
      setCount(120);
      setResendEnabled(false);
      setOtpRes(res);

      if (isForgotFlow) {
        setResetStep(2);
        return;
      }

      // NORMAL FLOW
      if (!res?.is_profileCreated) {
        setStep(2);
      } else {
        if (res?.is_password_set) {
          // Existing user with password → password screen
          setStep(2);
        } else {
          // New user OR no password → go to OTP first
          setIsSetPasswordFlow(true); // mark flow
          setStep(2); // go to OTP, NOT step 3
        }
      }
      if (!isResend) {
        recaptchaRef.current.reset();
        setCaptchaToken(null);
      }
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  const passwordVerify = async () => {
    if (errorMessageMail) {
      return;
    }

    try {
      setLoader(true);

      const data = {
        user_id: otpRes.user_id,
        role: otpRes.role,
        email: email,
        password: password
      };

      // console.log("data------", data);

      const resData = await apicall.ezp_password_verify(data);
      localStorage.setItem("login_type", "email");
      console.log("res---resData---", resData);

      console.log("otpRes---", otpRes);
      const role = await apicall.getRole();
      // console.log("role---", role);
      if (otpRes?.is_profileCreated) {
        if (isStaffRole(role) || isSupplierRole(role)) {
          navigate(staffLandingPath(role));
        } else if (role !== "3") {
          navigate("/vendors");
        } else {
          let isBasicSetupDone = await checkUserBasicSetup();
          if (!isBasicSetupDone) {
            navigate("/industry");
          } else {
            let isStepUpDone = await setUpIsDone();
            if (!isStepUpDone) {
              navigate("/setup");
            } else {
              navigate("/dashboard");
            }
          }
        }
      } else {
        navigate(`/profile-setup?email=${email}`, {
          state: {
            otpRes: otpRes
          }
        });
      }
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };
  const checkUserBasicSetup = async () => {
    try {
      let res = await apicall.get(
        `getUserOnboardingStatus?user_id=${otpRes.user_id}`
      );

      let ans = {
        industry: !!res?.data?.[0]?.industry,
        services: !!res?.data?.[0]?.services_location
      };
      return Object.values(ans).every(Boolean);
    } catch (e) {
      console.log("checkUserBasicSetup error---", e);
      return false;
    }
  };
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/;

  const handleSetPassword = async (flowType = "set") => {
    if (!newPassword) {
      toast.error("Please enter password");
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      setPasswordError(
        "Password must contain at least one uppercase letter, one lowercase letter and one number"
      );
      return;
    }

    if (flowType === "reset" && newPassword !== confirmPassword) {
      setPasswordError("Both passwords should match");
      return;
    }

    try {
      setLoader(true);

      const res = await apicall.post(
        {
          user_id: otpRes.user_id,
          password: newPassword,
          type: flowType === "reset" ? "reset_password" : "set_password"
        },
        "set_password"
      );

      if (res.success) {
        toast.success(
          flowType === "reset"
            ? "Password reset successful"
            : "Password set successfully"
        );

        if (flowType === "reset") {
          setStep(2);
          setPassword(newPassword);
          // passwordVerify();
          return;
        }

        localStorage.setItem("login_type", "email");

        const role = apicall.getRole();

        if (otpRes?.is_profileCreated) {
          if (isStaffRole(role) || isSupplierRole(role)) {
            navigate(staffLandingPath(role));
          } else if (role !== "3") {
            navigate("/vendors");
          } else {
            let isStepUpDone = await setUpIsDone();
            if (!isStepUpDone) {
              navigate("/setup");
            } else {
              navigate("/dashboard");
            }
          }
        } else {
          navigate(`/profile-setup?email=${email}`, {
            state: {
              otpRes: otpRes
            }
          });
        }
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader(false);
    }
  };
  // console.log("otpRes----", otpRes);

  const setUpIsDone = async () => {
    try {
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_types`),
        apicall.get(`get_ezp_service_providers?skill=PROFESSIONAL`),
        apicall.get(`get_ezp_booking?page=1&limit=1`)
      ]);
      // Clinic vendors (industry 1) never create sub-categories/service types —
      // that field is hidden for them in Admin Setup — so requiring one would
      // make setup completion permanently impossible for this industry.
      const isClinicService = Number(ezpMyProfile?.data?.[0]?.industry) === 1;
      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: isClinicService ? true : service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0
      };
      for (let i of Object.values(ans)) {
        if (!i) {
          return false;
        }
      }
      console.log(ans, "ans");

      return true;
    } catch (e) {
      console.log("setUpis Done---", e);
    }
  };
  const handleResend = () => {
    setOtp("");
    setErrorMessage("");
    setCaptchaError("");

    if (showMailLogin || isForgotPassword) {
      emailSend(true);
    } else {
      getOTP(true);
    }
  };
  // Verify OTP
  const verifyOtp = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }
    if (count === 0) {
      setOTPErrorMessage("OTP expired. Please request a new OTP.");
      return;
    }

    try {
      setLoader(true);

      const data = {
        mobileNumber: fullNumber,
        otp: otp,
        twilioService_id: otpRes.twilioService_id,
        user_id: otpRes.user_id,
        role: otpRes.role
      };

      let ans = await apicall.verifyOTP(data);
      localStorage.setItem("login_type", "phone");
      // console.log("ans-------", ans);
      const role = apicall.getRole();
      // console.log("role---", role);
      if (otpRes?.is_profileCreated) {
        if (isStaffRole(role) || isSupplierRole(role)) {
          navigate(staffLandingPath(role));
        } else if (role !== "3") {
          navigate("/vendors");
        } else {
          let isBasicSetupDone = await checkUserBasicSetup();
          if (!isBasicSetupDone) {
            navigate("/industry");
          } else {
            let isStepUpDone = await setUpIsDone();
            if (!isStepUpDone) {
              navigate("/setup");
            } else {
              navigate("/dashboard");
            }
          }
        }
      } else {
        navigate(`/profile-setup?phone_number=${fullNumber}`, {
          state: {
            otpRes: otpRes
          }
        });
      }
      // if (otpRes?.is_profileCreated) {
      //   let isStepUpDone = await setUpIsDone();
      //   if (!isStepUpDone) {
      //     // console.log("navigate to setup---");
      //     navigate("/setup");
      //   } else {
      //     // console.log("navigate to dashboard...---");
      //     navigate(role === "3" ? "/dashboard" : "/vendors");
      //   }
      // } else {
      //   navigate(`/profile-setup?phone_number=${fullNumber}`);
      // }
    } catch (e) {
      console.log("e--------verigyOTP-----", e);
      toast.error(e.message.replace("Error - verifyOtp:", ""));
    } finally {
      setLoader(false);
    }
  };

  const verifyCODE = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }

    if (count === 0) {
      setOTPErrorMessage("OTP expired. Please request a new OTP.");
      return;
    }

    // if (!captchaToken) {
    //   setCaptchaError("Please complete reCAPTCHA.");
    //   return;
    // }

    try {
      setLoader(true);

      const data = {
        mobileNumber: fullNumber,
        otp: otp,
        twilioService_id: otpRes.twilioService_id,
        user_id: otpRes.user_id,
        role: otpRes.role
      };

      let ans = await apicall.verifyCODE(data);
      if (isSetPasswordFlow) {
        setStep(3);
        return;
      }
      if (isForgotPassword) {
        setResetStep(3);
        return;
      }
      localStorage.setItem("login_type", "email");
      // console.log("ans-------", ans);
      const role = apicall.getRole();
      // console.log("role-verifycode--", role);

      if (otpRes?.is_profileCreated) {
        if (isStaffRole(role) || isSupplierRole(role)) {
          navigate(staffLandingPath(role));
        } else if (role !== "3") {
          navigate("/vendors");
        } else {
          let isStepUpDone = await setUpIsDone();
          if (!isStepUpDone) {
            navigate("/setup");
          } else {
            navigate("/dashboard");
          }
        }
      } else {
        navigate(`/profile-setup?email=${email}`, {
          state: {
            otpRes: otpRes
          }
        });
      }
    } catch (e) {
      console.log("e--------verigyOTP-----", e);
      toast.error(e.message.replace("Error - verifyOtp:", ""));
    } finally {
      setLoader(false);
    }
  };

  // Check if user is already logged in
  const isUserLoggedIn = useCallback(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const role = apicall.getRole();
      // navigate(role === "5" ? "/dashboard" : "/vendors");
    }
  }, [navigate]);

  // Handle Enter key press
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter" && !loader) {
  //     e.preventDefault();
  //     step === 1 ? getOTP() : showMailLogin ? verifyCODE() : verifyOtp();
  //   }
  // };
  const handleKeyDown = (e) => {
    if (step === 1) {
      getOTP();
    } else if (step === 2) {
      if (showMailLogin) {
        verifyCODE();
      } else if (isSetPasswordFlow) {
        verifyCODE();
      } else {
        verifyOtp();
      }
    }
  };
  // Timer for OTP resend
  useEffect(() => {
    let timer;

    const isOtpScreen = step === 2 || (step === 4 && resetStep === 2);

    if (isOtpScreen && count > 0) {
      timer = setTimeout(() => setCount((c) => c - 1), 1000);
    } else if (count === 0) {
      setResendEnabled(true);
    }

    return () => clearTimeout(timer);
  }, [count, step, resetStep]);

  // Check auth status on mount
  useEffect(() => {
    isUserLoggedIn();
  }, [isUserLoggedIn]);

  // Format timer display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  // Custom OTP input renderer (without keydown handler)
  const renderOtpInput = (props) => <input {...props} />;

  const handleChange = (event) => {
    try {
      setEmail(event.target.value);
    } catch (e) {
      console.log("err----", e);
    }
  };

  // console.log("----otpRes---", otpRes, step);

  return (
    <>
      <div>
        <Row
          className="profile_bg_color login_hero_bg w-100"
          onKeyDown={handleKeyDown}
        >
          <BrandLogo
            height={44}
            style={{ position: "absolute", top: "8px", left: "8px", zIndex: 2 }}
          />
          <Col md={8} className="flex_center">
            <div className="left_row login_hero_visual">
              <img
                src={login_hero_image}
                alt="Car service, clinic, salon, cleaning, events and coaching businesses run on one platform with an AI assistant, bookings, invoicing and team tools"
                className="login_hero_img"
              />
              <h1 className="title_head">
                Join Us and <span className="primary-word">Unlock</span> Endless{" "}
                <span className="primary-word">Possibilities!</span>
              </h1>

              <h6 className="title_sub_head">
                Access your account and manage your bookings easily. Stay
                connected with your services, track appointments, and enjoy a
                seamless experience with Utilstop.
              </h6>
            </div>
          </Col>
          <Col md={4} className="background-color-red">
            <div onKeyDown={handleKeyDown}>
              <div className="d-flex pt-5" style={{ marginRight: "35px" }}>
                <div
                  className="shadow-lg bg-body rounded sm-w-100 tab-adjust"
                  style={{ width: "500px" }}
                >
                  <div className="p-5 pt-4">
                    <div className=" mb-3">
                      <img
                        src={create_profile_icon}
                        alt={"create_profile_icon"}
                        style={{ width: "30px", height: "auto" }}
                      />
                      <h1 className="title_bold">Login</h1>
                    </div>
                    <div className="d-flex mb-4 normal_tab">
                      <div
                        className={
                          "p-2 w-50 cursor-pointer normal_tab d-flex align-items-center justify-content-center gap-2" +
                          (!showMailLogin ? " mobile-primary" : "")
                        }
                        onClick={() => {
                          setStep(1);
                          setOtpRes({});
                          setPassword("");
                          setShowMailLogin(false);
                        }}
                      >
                        <FaPhoneAlt />
                        <span>Phone</span>
                      </div>

                      <div
                        className={
                          "p-2 w-50 cursor-pointer normal_tab d-flex align-items-center justify-content-center gap-2" +
                          (showMailLogin ? " mobile-primary" : "")
                        }
                        onClick={() => {
                          setStep(1);
                          setOtpRes({});
                          setPassword("");
                          setShowMailLogin(true);
                        }}
                      >
                        <MdOutlineEmail />
                        <span>Email</span>
                      </div>
                    </div>
                    {step === 1 && (
                      <>
                        {!showMailLogin ? (
                          <div
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.stopPropagation();
                                getOTP();
                              }
                            }}
                          >
                            <div className="">
                              <label
                                htmlFor="phone"
                                className="label text-dark"
                              >
                                Enter Phone Number
                              </label>
                              <PhoneInput
                                onlyCountries={["in", "ae"]}
                                country={"in"}
                                value={fullNumber}
                                onChange={(value, country, formattedValue) =>
                                  numberOnChanges(
                                    value,
                                    country,
                                    formattedValue
                                  )
                                }
                                inputStyle={{ width: "100%" }}
                                enableSearch={false}
                                masks={{
                                  ae: "... ... ...", //  strictly 9 digits
                                  in: "..... ....." //  10 digits
                                }}
                              />

                              {errorMessage && (
                                <div className="label text-danger">
                                  {errorMessage}
                                </div>
                              )}
                            </div>
                            <div className="consent-text">
                              By continuing, you agree to{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open(
                                    "https://ezeitpro.com/terms",
                                    "_blank"
                                  )
                                }
                              >
                                EzeitPro Customer Agreement
                              </span>{" "}
                              or other agreement for UtilStop, and the{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open(
                                    "https://ezeitpro.com/privacy-policy",
                                    "_blank"
                                  )
                                }
                              >
                                Privacy Notice
                              </span>
                              . This site uses essential cookies. See our{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open(
                                    "https://ezeitpro.com/privacy-policy#cookies",
                                    "_blank"
                                  )
                                }
                              >
                                Cookie Notice
                              </span>{" "}
                              for more information.
                            </div>
                            <div className="d-flex flex-column justify-content-center mt-3 align-items-center">
                              <ReCAPTCHA
                                ref={recaptchaRef} // optional if you want to reset
                                sitekey={constants?.WEB_CAPTCHA_TOKEN}
                                onChange={(token) => {
                                  setCaptchaToken(token);
                                  setCaptchaError(""); // clear error when captcha is completed
                                }}
                              />
                              {captchaError && (
                                <div className="label text-danger mt-2">
                                  {captchaError}
                                </div>
                              )}
                            </div>

                            <div className="text-center pt-4">
                              <button
                                style={{ marginLeft: "40%" }}
                                className="btn btn-block primaryBackground text-white"
                                onClick={() => getOTP()}
                                disabled={loader || !captchaToken}
                              >
                                {loader ? (
                                  <Loader style={{ width: 40, height: 20 }} />
                                ) : (
                                  "Get OTP"
                                )}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              emailSend();
                            }}
                          >
                            <div
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.stopPropagation();
                                  emailSend();
                                }
                              }}
                            >
                              <div className="">
                                <label
                                  htmlFor="phone"
                                  className="label text-dark"
                                >
                                  Enter Email ID
                                </label>

                                <Form.Group>
                                  <Form.Control
                                    type="text"
                                    name="email"
                                    placeholder="Enter email address"
                                    value={email}
                                    onChange={(e) => {
                                      const value = e.target.value.trim();
                                      setEmail(value);

                                      const emailRegex =
                                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                                      if (value && !emailRegex.test(value)) {
                                        setErrorMessageMail(
                                          "Enter valid email"
                                        );
                                      } else {
                                        setErrorMessageMail("");
                                      }
                                    }}
                                    className="form-input"
                                    required
                                  />

                                  {errorMessageMail && (
                                    <div className="label text-danger">
                                      {errorMessageMail}
                                    </div>
                                  )}
                                </Form.Group>
                              </div>
                              <div className="consent-text">
                                By continuing, you agree to{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/terms",
                                      "_blank"
                                    )
                                  }
                                >
                                  EzeitPro Customer Agreement
                                </span>{" "}
                                or other agreement for UtilStop, and the{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/privacy-policy",
                                      "_blank"
                                    )
                                  }
                                >
                                  Privacy Notice
                                </span>
                                . This site uses essential cookies. See our{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/privacy-policy#cookies",
                                      "_blank"
                                    )
                                  }
                                >
                                  Cookie Notice
                                </span>{" "}
                                for more information.
                              </div>
                              <div className="d-flex flex-column justify-content-center mt-3 align-items-center">
                                <ReCAPTCHA
                                  ref={recaptchaRef} // optional if you want to reset
                                  sitekey={constants?.WEB_CAPTCHA_TOKEN}
                                  onChange={(token) => {
                                    setCaptchaToken(token);
                                    setCaptchaError(""); // clear error when captcha is completed
                                  }}
                                />
                                {captchaError && (
                                  <div className="label text-danger mt-2">
                                    {captchaError}
                                  </div>
                                )}
                              </div>
                              <div className="text-center pt-4">
                                <button
                                  style={{ marginLeft: "40%" }}
                                  className="btn btn-block primaryBackground text-white"
                                  // onClick={emailSend}
                                  disabled={loader || !captchaToken}
                                >
                                  {loader ? (
                                    <Loader style={{ width: 40, height: 20 }} />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        )}
                      </>
                    )}
                    {step == 2 && (
                      <>
                        {otpRes?.is_password_set && showMailLogin ? (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              passwordVerify();
                            }}
                          >
                            <div
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.stopPropagation();
                                  passwordVerify();
                                }
                              }}
                            >
                              {/* <div className="">
                        <label htmlFor="phone" className="label text-dark">
                          Password
                        </label>

                        <Form.Group>
                          <Form.Control
                            type="text"
                            name="email"
                            value={password}
                            placeholder="Enter password"
                            onChange={(e) => {
                              const value = e.target.value;
                              setPassword(value);
                            }}
                            className="form-input"
                          />
                        </Form.Group>
                      </div> */}
                              <div>
                                <label
                                  htmlFor="password"
                                  className="label text-dark"
                                >
                                  Password
                                </label>

                                <Form.Group style={{ position: "relative" }}>
                                  <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    placeholder="Enter password"
                                    required
                                    autoComplete="current-password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="form-input"
                                    style={{ paddingRight: "40px" }}
                                  />

                                  <span
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    style={{
                                      position: "absolute",
                                      right: "12px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      color: "#6c757d"
                                    }}
                                  >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                  </span>
                                </Form.Group>
                              </div>
                              <div className="text-end mt-2">
                                <span
                                  style={{
                                    cursor: "pointer",
                                    color: "#d01c4c"
                                  }}
                                  onClick={() => {
                                    setIsForgotPassword(true);
                                    setResetStep(1);
                                    setStep(4);
                                  }}
                                >
                                  Forgot Password?
                                </span>
                              </div>

                              <div className="text-center pt-4">
                                <button
                                  style={{ marginLeft: "40%" }}
                                  className="btn btn-block primaryBackground text-white"
                                  // onClick={passwordVerify}
                                  disabled={loader}
                                >
                                  {loader ? (
                                    <Loader style={{ width: 40, height: 20 }} />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        ) : (
                          <div
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.stopPropagation();
                                showMailLogin ? verifyCODE() : verifyOtp();
                              }
                            }}
                          >
                            <div className="greyColor">
                              Enter the code we just sent on your{" "}
                              {showMailLogin ? "mail" : "phone"}
                            </div>
                            {!showMailLogin ? (
                              <div className="primaryColorText">
                                +{countryCode} {phoneNumber}
                              </div>
                            ) : (
                              <div className="primaryColorText">{email}</div>
                            )}

                            <div className="d-flex justify-content-center  otp-wrapper">
                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span>&nbsp;&nbsp;</span>}
                                renderInput={renderOtpInput}
                                containerStyle={{
                                  width: "70%",
                                  height: "100px",
                                  alignItems: "center"
                                }}
                                inputStyle={{ width: "40%", height: "50%" }}
                              />
                            </div>

                            {OTPErrorMessage && (
                              <div className="label text-danger text-center">
                                {OTPErrorMessage}
                              </div>
                            )}

                            <div className="text-center">
                              <button
                                style={{ marginLeft: "40%" }}
                                className="btn btn-block primaryBackground text-white"
                                onClick={() => {
                                  if (showMailLogin) {
                                    verifyCODE();
                                  } else {
                                    verifyOtp();
                                  }
                                }}
                                disabled={loader || otp.length !== 6}
                              >
                                {loader ? (
                                  <Loader style={{ width: 40, height: 20 }} />
                                ) : !showMailLogin ? (
                                  "Login"
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            </div>

                            {resendEnabled ? (
                              <div
                                className="text-center pt-2 primaryColorText"
                                onClick={handleResend}
                                style={{ cursor: "pointer" }}
                              >
                                <u>Resend {showMailLogin ? "Code" : "OTP"}</u>
                              </div>
                            ) : (
                              <div className="greyColor text-center pt-2">
                                Resend OTP in{" "}
                                <span className="primaryColorText">
                                  {formatTime(count)}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    {step === 3 && isSetPasswordFlow && (
                      <div>
                        <label
                          className="label text-dark"
                          onKeyDown={handleKeyDown}
                        >
                          Password
                        </label>

                        <Form.Group style={{ position: "relative" }}>
                          <Form.Control
                            type={showNewPassword ? "text" : "password"}
                            value={newPassword}
                            placeholder="Enter new password"
                            required
                            autoComplete="new-password"
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="form-input"
                            style={{ paddingRight: "40px" }}
                          />

                          <span
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#6c757d"
                            }}
                          >
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </Form.Group>
                        {passwordError && (
                          <div className="label text-danger mt-2">
                            {passwordError}
                          </div>
                        )}
                        <div className="text-center">
                          <button
                            style={{ marginLeft: "40%", marginTop: "20px" }}
                            className="btn btn-block primaryBackground text-white"
                            onClick={() => handleSetPassword("set")}
                          >
                            {loader ? (
                              <Loader style={{ width: 40, height: 20 }} />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                    {step === 4 && isForgotPassword && (
                      <>
                        {/* STEP 4.1 → ENTER EMAIL */}
                        {resetStep === 1 && (
                          <div>
                            <label className="label text-dark">
                              Enter Email
                            </label>

                            <Form.Control
                              type="text"
                              value={email}
                              placeholder="Enter your email"
                              disabled
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <div className="text-center">
                              <button
                                style={{ marginLeft: "40%", marginTop: "20px" }}
                                className="btn btn-block primaryBackground text-white"
                                onClick={() => emailSend(false, true)}
                              >
                                {loader ? (
                                  <Loader style={{ width: 40, height: 20 }} />
                                ) : (
                                  " Send OTP"
                                )}
                              </button>
                            </div>
                          </div>
                        )}

                        {/* STEP 4.2 → OTP VERIFY */}
                        {resetStep === 2 && (
                          <div>
                            <div className="greyColor">
                              Enter the code we just sent on your mail {email}
                            </div>
                            <div className="d-flex justify-content-center  otp-wrapper">
                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span>&nbsp;&nbsp;</span>}
                                renderInput={renderOtpInput}
                                containerStyle={{
                                  width: "70%",
                                  height: "100px",
                                  alignItems: "center"
                                }}
                                inputStyle={{ width: "40%", height: "50%" }}
                              />
                            </div>
                            {OTPErrorMessage && (
                              <div className="label text-danger text-center">
                                {OTPErrorMessage}
                              </div>
                            )}

                            <button
                              style={{ marginLeft: "40%" }}
                              className="btn btn-block primaryBackground text-white"
                              onClick={verifyCODE}
                            >
                              Verify OTP
                            </button>
                            {resendEnabled ? (
                              <div
                                className="text-center pt-2 primaryColorText"
                                onClick={handleResend}
                                style={{ cursor: "pointer" }}
                              >
                                <u>Resend Code</u>
                              </div>
                            ) : (
                              <div className="greyColor text-center pt-2">
                                Resend Code in{" "}
                                <span className="primaryColorText">
                                  {formatTime(count)}
                                </span>
                              </div>
                            )}
                          </div>
                        )}

                        {resetStep === 3 && (
                          <div>
                            {/* NEW PASSWORD */}
                            <label className="label text-dark">
                              New Password
                            </label>

                            <Form.Group style={{ position: "relative" }}>
                              <Form.Control
                                type={
                                  showNewForgotPassword ? "text" : "password"
                                }
                                value={newPassword}
                                placeholder="Enter new password"
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="form-input"
                                style={{ paddingRight: "40px" }}
                              />

                              <span
                                onClick={() =>
                                  setShowNewForgotPassword(
                                    !showNewForgotPassword
                                  )
                                }
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#6c757d"
                                }}
                              >
                                {showNewForgotPassword ? (
                                  <FaEyeSlash />
                                ) : (
                                  <FaEye />
                                )}
                              </span>
                            </Form.Group>

                            {/* CONFIRM PASSWORD */}
                            <label className="label text-dark mt-3">
                              Confirm Password
                            </label>

                            <Form.Group style={{ position: "relative" }}>
                              <Form.Control
                                type={showConfirmPassword ? "text" : "password"}
                                value={confirmPassword}
                                placeholder="Confirm password"
                                autoComplete="new-password"
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="form-input"
                                style={{ paddingRight: "40px" }}
                              />

                              <span
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#6c757d"
                                }}
                              >
                                {showConfirmPassword ? (
                                  <FaEyeSlash />
                                ) : (
                                  <FaEye />
                                )}
                              </span>
                            </Form.Group>
                            {passwordError && (
                              <div className="label text-danger mt-2">
                                {passwordError}
                              </div>
                            )}

                            <button
                              style={{ marginLeft: "32%", marginTop: "20px" }}
                              className="btn btn-block primaryBackground text-white"
                              onClick={() => handleSetPassword("reset")}
                            >
                              {loader ? (
                                <Loader style={{ width: 40, height: 20 }} />
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Login;
